import ApiService from '@shared/services/api.service';

const endPoint = '/policies';
const urlsEndPoint = '/urls/simple';

const PolicyService = {
  getList() {
    return ApiService.get(endPoint);
  },

  async getUrlList(options = {}) {
    const { 
      page = null, 
      itemsPerPage = 1000, 
      q = '', 
      userId = null,
    } = options;
    
    // Build query string
    const params = new URLSearchParams();
    
    if (page) {
      params.append('page', page);
    }
    params.append('items_per_page', itemsPerPage);
    
    if (q) {
      params.append('q', q);
    }
    
    if (userId) {
      params.append('user_id', userId);
    }
    
    const url = `${urlsEndPoint}?${params.toString()}`;
    const response = await ApiService.get(url);
    
    // Handle non-paginated response (backwards compatibility)
    if (Array.isArray(response)) {
      return response;
    }
    
    // If page was specified, return paginated response as-is
    if (page) {
      return response;
    }
    
    // No page specified: fetch all pages by getting 1 first, then fetch remaining pages in batches
    if (response && response.data && response.meta) {
      let allData = [...response.data];
      const { current_page, last_page } = response.meta;
      
      // Fetch remaining pages if there are more
      if (current_page < last_page) {
        const pagePromises = [];
        for (let p = current_page + 1; p <= last_page; p++) {
          pagePromises.push(ApiService.get(`${url}&page=${p}`));
        }
        
        const pageResponses = await Promise.all(pagePromises);
        for (const pageResponse of pageResponses) {
          if (pageResponse && Array.isArray(pageResponse.data)) {
            allData = allData.concat(pageResponse.data);
          }
        }
      }
      
      return allData;
    }
    
    // Fallback: return response as-is if structure is unexpected
    return response || [];
  },

  create(bodyParams) {
    return ApiService.post(`${endPoint}`, bodyParams);
  },

  update(policy, bodyParams) {
    return ApiService.put(`${endPoint}/${policy}`, bodyParams);
  },

  get(policy) {
    return ApiService.get(`${endPoint}/${policy}`);
  },

  delete(policy) {
    return ApiService.delete(`${endPoint}/${policy}`);
  }
};
export default PolicyService;
